<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">
    <div class="mt-8 grid gap-8 max-w-3xl mx-auto">
      <div class="grid gap-4 md:gap-6">
        <div class="text-coral mx-auto">
          <AtomIcon name="bb-logo-name" class="text-5xl" />
        </div>
        <div class="grid gap-2 text-center">
          <h1 class="font-heading font-medium text-2xl sm:text-3xl">{{ $t('pages.start.heading') }}</h1>
          <p class="text-sm">{{ $t('pages.start.leading') }}</p>
        </div>
      </div>
      <StartCities />
      <hr class="my-8">
      <StartCornerstone />
    </div>
  </div>
</template>

<script setup>
// 
</script>